import { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import FieldSearch from './FieldSearch'


export default function FieldAssignments(props) {
  /*
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * required = <boolean> Optional
   * value = <string> Required
   * placeholder = <string> Optional
   * valid = <boolean> Optional
   * validMessage = <string> Optional
   * invalidMessage = <string> Optional
   * help = <string> Optional
   * helpAboveInput = <boolean> Optional
   * onChange = <function()> Required
   * onChangeColors = <function()> Optional
   * onBlur = <function()> Optional
   * disabled = <boolean> Optional
   * readOnly = <boolean> Optional
   * prepend = <string> Optional
   * append = <string> Optional
   * multiple = <boolean> Optional
   * horizontal = <boolean> Optional
   * horizontalLabelSize = <int [1-23]> Optional (Default = 6)
   */

  const value = useMemo(() => {
    if (props.multiple) {
      return Array.isArray(props.value) ? props.value.map(v => v?.uuid).filter(v => v) : []
    }
    return props.value?.uuid || null
  }, [props.value])

  const onChange = useCallback(
    typeof props.onChange === "function" ? (event, value) => props.onChange({ target: { value } }) : (event, value) => console.log(value),
    [props.onChange]
  )
  const onBlur = useCallback(
    typeof props.onBlur === "function" ? (event, value) => props.onBlur({ target: { value } }) : undefined,
    [props.onBlur]
  )

  return (
    <FieldSearch
      ref={props.inputRef}
      className={props.className}
      labelClassName={props.labelClassName}
      inputClassName={props.inputClassName}
      label={props.label}
      required={props.required}
      value={value}
      placeholder={props.placeholder}
      valid={props.valid}
      validMessage={props.validMessage}
      invalidMessage={props.invalidMessage}
      help={props.help}
      helpAboveInput={props.helpAboveInput}
      onChange={onChange}
      onBlur={onBlur}
      disabled={props.disabled}
      readOnly={props.readOnly}
      prepend={props.prepend}
      append={props.append}
      multiple={props.multiple}
      api={{
        url: "api/assignments/",
        response: { array: ["data"], label: ["name"], value: ["uuid"], }
      }}
      horizontal={props.horizontal}
      horizontalLabelSize={props.horizontalLabelSize}
      autoFocus={props.autoFocus}
    />
  )
}

FieldAssignments.propTypes = {
  inputRef: PropTypes.func,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.object)
  ]),
  placeholder: PropTypes.string,
  valid: PropTypes.bool,
  validMessage: PropTypes.string,
  invalidMessage: PropTypes.string,
  help: PropTypes.string,
  helpAboveInput: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  prepend: PropTypes.string,
  append: PropTypes.string,
  multiple: PropTypes.bool,
  horizontal: PropTypes.bool,
  horizontalLabelSize: PropTypes.number,
  autoFocus: PropTypes.bool,
}
